import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { getOrders } from '../../../redux/actions/orderActions';
import { store } from '../../../redux/store/configureStore';
import OrderSummary from '../../molecules/OrderSummary';
import LoadingSpinner from '../../atoms/LoadingSpinner/';
import MessageBanner from '../../atoms/MessageBanner';

export class OrderSummaries extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }
  componentDidMount() {
    this.props.getOrders();
  }
  componentWillReceiveProps() {
    this.setState({ loading: false });
  }
  generateMessage() {
    let message = 'Hello';
    if (this.props.orders && this.props.orders.customerName) {
      message += ` ${`${this.props.orders.customerName} (${this.props.orders.customerId})`}`;
    }

    if (this.props.orders
      && this.props.orders.orders
      && this.props.orders.orders.length > 0) {
      message += ', here you can view all your open and previously placed orders.';
    } else {
      message += ', you currently have no open or previously placed orders.';
    }

    return message;
  }

  renderOrderSummary() {
    return (
      this.props.orders.orders.map((order) => (
        <OrderSummary
          className="orderInfo"
          key={order.transactionId}
          transactionId={order.transactionId}
          deliveryDate={order.expectedDeliveryDate}
          orderStatus={order.status}
          orderValue={order.totalPrice}
          orderDate={order.orderPlacedDate}
          custName={this.props.orders.customerName}
        />
      ))
    );
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    } else if (this.props.errors) {
      store.dispatch(push({ pathname: `/error-screen/${this.props.errors && this.props.errors.response && this.props.errors.response.status}` }));
    }
    return (
      <div>
        <MessageBanner message={this.generateMessage()} />
        {this.props.orders && this.props.orders.orders && this.renderOrderSummary()}
      </div>
    );
  }
}

OrderSummaries.propTypes = {
  getOrders: PropTypes.func.isRequired,
  orders: PropTypes.instanceOf(Object),
  errors: PropTypes.string,
};

OrderSummaries.defaultProps = {
  orders: PropTypes.instanceOf(Object),
  errors: '',
};

const mapStateToProps = state => ({
  orders: state.order.orders,
  errors: state.order.error,
});

const mapDispatchToProps = {
  getOrders,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaries);



// WEBPACK FOOTER //
// src/components/organisms/OrderSummaries/index.jsx